<template>
<div id="mes-Reclammations" class="data-list-container">

    <vs-popup class="holamundo" title="Feedback" :active.sync="popupActiveReponse">
        <p v-html="Reponse"></p>
    </vs-popup>

    <vs-popup title="Nouvelle Réclammation" :active.sync="popupActive">
        <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body">
                <!-- Content Row -->

                <div class="text-center py-1 m-5">
                    <label class="block text-gray-700 text-sm font-bold mb-2"> Type</label>
                    <div>
                        <v-select v-validate="'required'" label="designation" v-model="type" :options="types" name="gouvernorat" />

                    </div>
                </div>

                <div class="text-center py-1 m-5">
                    <label class="block text-gray-700 text-sm font-bold mb-2">Libellé</label>
                    <div>
                        <vs-textarea v-model="recText" :counter-danger.sync="counterDanger" height="100px" label="Vous pouvez mettre ici ce que vous voulez .." counter="200" class="w-full" />
                    </div>
                </div>

                <!-- Save & Reset Button -->

                <div class="vx-row">
                    <div class="vx-col w-full">
                        <div class="text-center py-1 m-5 justify-end">
                            <!-- <vs-button >Envoyer</vs-button> -->
                            <vs-button :disabled="!validateForm" @click="envoyer" class="ml-auto mt-2" color="primary" icon-pack="feather" icon="icon-send">Envoyer</vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </vs-popup>

    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="Reclammations">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <!-- ITEMS PER PAGE -->
            <vs-button color="primary" type="border" icon-pack="feather" icon="icon-file-plus" @click="OpenModal">Réclammer</vs-button>
        </div>
        <template slot="thead">
            <vs-th class="w-2/12" sort-key="type">Type</vs-th>
            <vs-th class="w-6/12" sort-key="designation">Description</vs-th>
            <vs-th class="w-2/12" sort-key="date">Date</vs-th>
            <vs-th class="w-2/12">Etat</vs-th>
        </template>

        <template slot-scope="{data}">
            <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <p class="product-name font-medium truncate">{{ tr.type }}</p>
                    </vs-td>

                    <vs-td>
                        <p>{{ tr.designation.substring(0,100) }}</p>
                    </vs-td>

                    <vs-td>
                        <p>{{ tr.date }}</p>
                    </vs-td>

                    <vs-td class="flex justify-center">
                        <div v-if="tr.etat == 0">
                            <feather-icon icon="EditIcon" @click="edit(tr.id,tr.type,tr.designation)" color="primary" svgClasses="w-5 h-5 hover:text-primary stroke-current" />
                            <feather-icon icon="Trash2Icon" @click="deleteRec(tr.id)" color="danger" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" />
                            <!-- <vs-button size="small" radius color="danger" type="gradient" icon-pack="feather" icon="icon-x-circle"></vs-button>
                            <vs-button size="small" radius color="danger" type="gradient" icon-pack="feather" icon="icon-x-circle"></vs-button> -->
                        </div>
                        <vs-button v-else @click="openReponse(tr.id)" size="small" radius color="primary" type="gradient" icon-pack="feather" icon="icon-search"></vs-button>
                    </vs-td>

                </vs-tr>
            </tbody>
        </template>
    </vs-table>

</div>
</template>

<script>
import index from "../../http/requests/reclammation/index.js";
import vSelect from "vue-select";
export default {
    components: {
        "v-select": vSelect
    },
    data() {
        return {
            recText: '',
            counterDanger: false,
            popupActive: false,
            popupActiveReponse: false,
            Reponse: '',
            isUpdate: false,
            idRec: 0,
            isMounted: false,
            itemsPerPage: 10,
            Reclammations: [],
            types: [{
                    id: 1,
                    designation: 'Réclammation d\'ordre Commercial'
                },
                {
                    id: 2,
                    designation: 'Réclammation d\'ordre Financier'
                },
                {
                    id: 3,
                    designation: 'Autre'
                }
            ],
            type: {}
        };
    },
    watch: {
        Reclammations: function (val) {
            if (val.length > 0) {
                this.$vs.loading.close("#mes-Reclammations > .con-vs-loading");
            }
        }
    },
    computed: {
        validateForm() {
            return (this.type != {} && this.recText != '')
        },
        currentPage() {
            if (this.isMounted) {
                return this.$refs.table.currentx;
            }
            return 0;
        },
        queriedItems() {
            return this.$refs.table ?
                this.$refs.table.queriedResults.length :
                this.Reclammations.length;
        }
    },
    methods: {
        LoadData() {
            index.getAll(this.$store.state.AppActiveUser.id).then(response => {
                console.log(response)
                this.Reclammations = response.data;
                if (response.data.length == 0) {
                    this.$vs.loading.close("#mes-Reclammations > .con-vs-loading");
                    this.$vs.loading.close();
                }
            }).catch(error => {
                this.$vs.loading.close("#mes-Reclammations > .con-vs-loading");
                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Erreur s'est produite lors de la récupération des données",
                    text: error.data,
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circles"
                });
            });
        },
        OpenModal() {
            this.isUpdate = false;
            this.popupActive = true;
        },
        envoyer() {
            var body;
            if (this.isUpdate) {
                body = {
                    typeRec: this.type.designation,
                    descriptionRec: this.recText.substring(0, 250),
                    id: this.$store.state.AppActiveUser.id,
                    idRec: this.idRec
                }
                index.update(body).then(response => {
                    if (response.status == 200) {
                        this.type = {};
                        this.recText = ''
                        this.popupActive = false
                        this.LoadData();
                        this.$swal.fire({
                            position: 'absolute',
                            icon: 'success',
                            title: 'Réclammation modifiée avec succès .',
                            showConfirmButton: true,
                            timer: 2500
                        })
                    }
                }).catch(error => {
                    this.type = {};
                    this.recText = ''
                    this.popupActive = false
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.data
                    })
                });
            } else {
                body = {
                    typeRec: this.type.designation,
                    descriptionRec: this.recText.substring(0, 250),
                    id: this.$store.state.AppActiveUser.id
                }
                index.add(body).then(response => {
                    if (response.status == 200) {
                        this.type = {};
                        this.recText = ''
                        this.popupActive = false
                        this.LoadData();
                        this.$swal.fire({
                            position: 'absolute',
                            icon: 'success',
                            title: 'Réclammation envoyée avec succès .',
                            showConfirmButton: true,
                            timer: 2500
                        })
                    }
                }).catch(error => {
                    this.type = {};
                    this.recText = ''
                    this.popupActive = false
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.data
                    })
                });
            }
        },
        openReponse(id) {
            this.Reclammations.forEach(element => {
                if (element.id == id) {
                    this.Reponse = element.reponse
                    this.popupActiveReponse = true;
                    return;
                }
            });
        },
        edit(id, type, designation) {
            this.idRec = id;
            this.isUpdate = true;
            this.recText = designation
            this.type = {
                id: 0,
                designation: type
            }
            this.popupActive = true
        },
        deleteRec(id) {
             this.$swal
        .fire({
          title: "Êtes-vous sûr ?",
          text: "Vous ne pourrez pas revenir en arrière!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#28C76F",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, supprime le !",
        }).then((result) => {
          if (result.value) {
            this.$swal.fire({
              position: "absolute",
              icon: "success",
              title: "Le compte a été supprimé.",
              showConfirmButton: false,
              timer: 1500,
            }),
              index.delete(id).then(response => {
                if (response.status == 200) {
                    this.LoadData();
                    this.$swal.fire({
                        position: 'absolute',
                        icon: 'success',
                        title: 'Réclammation supprimée avec succès .',
                        showConfirmButton: true,
                        timer: 2500
                    })
                }
            }).catch(error => {
                this.$swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: error.response.data
                })
            });
          }
        });
            /* index.delete(id).then(response => {
                if (response.status == 200) {
                    this.LoadData();
                    this.$swal.fire({
                        position: 'absolute',
                        icon: 'success',
                        title: 'Réclammation supprimée avec succès .',
                        showConfirmButton: true,
                        timer: 2500
                    })
                }
            }).catch(error => {
                this.$swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: error.response.data
                })
            }); */
        }
    },
    created() {
        if (this.$store.state.AppActiveUser.id != 0) {
            this.LoadData()
        }
        this.$store.subscribe(mutation => {
            if (mutation.type === "UPDATE_USER_INFO") {
                this.LoadData()
            }
        });
    },
    mounted() {
        this.isMounted = true;
        this.$vs.loading({
            background: this.backgroundLoading,
            // color: this.colorLoading,
            type: 'radius',
            container: "#mes-Reclammations",
            scale: 0.45,
            clickEffect: true
        });
    }
};
</script>

<style lang="scss">
#mes-Reclammations {

    font-family: 'Avenir',
        Helvetica,
        Arial,
        sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000000;

    .vs-table {
        border-collapse: separate;
        // border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr {
            box-shadow: 0 2px 20px 0 rgba(0, 0, 0, .05);

            td {
                align-items: center;
                justify-content: center;
                text-align: center;
                vertical-align: middle;

                &:first-child {
                    border-top-left-radius: 0.5rem;
                    border-bottom-left-radius: 0.5rem;
                }

                &:last-child {
                    border-top-right-radius: 0.5rem;
                    border-bottom-right-radius: 0.5rem;
                }

                &.img-container {
                    span {
                        display: flex;
                        justify-content: flex-start;
                    }

                    .product-img {
                        height: 110px;
                    }
                }
            }
        }

        .vs-table--thead {
            th {
                padding-top: 5;
                padding-bottom: 5;
                color: "primary";
                background: #002b5c;
                justify-content: center;

                .vs-table-text {
                    //text-transform: uppercase;
                    font-weight: 600;
                    color: white;
                    justify-content: center;
                }
            }
        }
    }

    @media (max-width: 461px) {
        .items-per-page-handler {
            display: none;
        }
    }

    @media (max-width: 341px) {
        .data-list-btn-container {
            width: 100%;

            .dd-actions,
            .btn-add-new {
                width: 100%;
                margin-right: 0 !important;
            }
        }
    }

    .product-name {
        max-width: 23rem;
    }

    .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        >span {
            display: flex;
            flex-grow: 1;
        }

        .vs-table--search {
            padding-top: 0;

            .vs-table--search-input {
                padding: 0.9rem 2.5rem;
                font-size: 1rem;

                &+i {
                    left: 1rem;
                }

                &:focus+i {
                    left: 1rem;
                }
            }
        }
    }
}
</style>
